import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table, Modal, message, Form, Input, Upload, Icon, Radio } from 'antd'
import Wangeditor from '../../commponents/wangeditor/index'
import UploadQiniu from '../../commponents/uploadQiniu/index'
const FormItem = Form.Item;
class VotingActivities extends Component {

	constructor(props) {
		super(props)
		this.childRef = React.createRef();
		this.state = {
			name: '',
			userName: '',
			fileType: 0,
			slogan: '',
			introduce: '',
			departmentName: '',
			visible: false,
			showType: false,
			token: '',
			zmToken: '',
			url: '',
			modelTitel: '新增部门模板',
			subjectIcon: '',
			voteUrl: '',
			introduction: '',
			dataSource: [],
			qiuniuUrl: '',
			qrcodeId: null,
			searchData: {
				total: 0,
				pageNum: 1,
				pageSize: 10
			},
			
			columns: [
				{
					title: '参与人编号',
					dataIndex: 'num',
					key: 'num',
					align: 'center',
				},
				{
					title: '参与人姓名',
					dataIndex: 'userName',
					key: 'userName',
					align: 'center'
				},
				{
					title: '票数',
					dataIndex: 'ticketNum',
					key: 'ticketNum',
					align: 'center'
				},
				{
					title: '名次',
					dataIndex: 'ranking',
					key: 'ranking',
					align: 'center'
				},
				{
					title: '创建人',
					dataIndex: 'createName',
					key: 'createName',
					align: 'center'
				},
				{
					title: '创建时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					render: (record) => <div>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							this.setState({
								visible: true,
								modelTitel: '编辑',
								userName: record.userName,
								fileType: record.fileType,
								slogan: record.slogan,
								introduce: record.proDetails,
								qrcodeId: record.id,
								worksUrl: {
									uid: null,
									type: null,
									url: record.worksUrl,
									name: record.userName
								},
								voteUrl: {
									uid: null,
									type: null,
									url: record.worksUrl,
									name: record.userName
								},
								// subjectIcon: {
								// 	uid: null,
								// 	type: null,
								// 	url: record.worksUrl,
								// 	name: record.userName
								// },
							})
						}}>编辑</span>
						<span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '删除',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p>删除后不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									this.delQscode(record.id)
								},
							});
						}}>删除</span>
					</div>
				},
			]
		}
	}

	handleOk = (e) => {
		let ary = [`fileType`,`introduce`, `slogan`,`userName`];
		if(this.state.fileType === 0) {
			ary.push('worksUrl')
		}else {
			ary.push('voteUrl')
		}
		this.props.form.validateFieldsAndScroll(ary,(err, values) => {
			console.log(values, '参数值');
			if(values.fileType === 1) {
				let picUrl = values.voteUrl.response ? this.state.qiuniuUrl+'/'+ values.voteUrl.response.key : ''
				values.worksUrl = values.voteUrl.url ? values.voteUrl.url: picUrl 
				// values.worksUrl = this.state.qrcodeId ? (values.voteUrl.url ? values.voteUrl.url: picUrl ) : picUrl
			}
			delete values.voteUrl
			if (!err) {
        try {
          if (this.state.modelTitel === '编辑') {
						if(values.fileType === 0) {
							var pic = '';
							let urlList = values.worksUrl;
							if(urlList.length === 1 && urlList[0].url) {
								pic = urlList[0].url
							} else { 
								pic = this.state.url + '/' + urlList[urlList.length - 1].response.key
							}
						}
           
            // let pic = this.state.url + '/' + values.worksUrl[values.worksUrl.length - 1].response.key
            axios.post('activityController/updateActivityVoteDetails', {
              userName: values.userName,
              activityId: 1,
							fileType: values.fileType,
              // worksUrl: pic,
							worksUrl:  values.fileType === 1 ? values.worksUrl : pic,
              activityVoteDetailId: this.state.qrcodeId,
              proDetails: values.introduce,
              slogan: values.slogan,
            }).then(res => {
              if (res.data.code === '200') {
                this.setState({ visible: false })
                message.success('修改成功')
                this.getList()
              } else {
                message.error(res.data.msg)
              }
            })
          } else {
            axios.post('activityController/addActivityVoteDetails', {
              activityId: 1,
							fileType: values.fileType,
              userName: values.userName,
							worksUrl:  values.fileType === 1 ? values.worksUrl : this.state.url + '/' + values.worksUrl[0].response.key ,
              // worksUrl: this.state.url + '/' + values.worksUrl[0].response.key,
              slogan: values.slogan,
              proDetails: values.introduce,
              persistentId:values.worksUrl&&values.worksUrl[0].response ? values.worksUrl[0].response.persistentId : '',
							// persistentId: values.worksUrl[0].response.persistentId
            }).then(res => {
              if (res.data.code === '200') {
                this.setState({ visible: false })
                message.success('新增成功')
                this.getList()
              } else {
                message.error(res.data.msg)
              }
            })
          }
        } catch (error) {
          console.log(error);
        }
			}
		});
	}
	componentDidMount() {
		this.getList()
		this.getToken()
		this.getZmToken()
	}
	showModal() {
		this.setState({
			visible: true,
			modelTitel: '新增',
			subjectIcon: '',
			introduce: '',
			slogan: '',
			fileType: 0,
		}, () => {

		})
	}
	radioChange = (e) => {
		this.setState({fileType: e.target.value},() => {
			this.props.form.setFieldsValue({
				// voteUrl: '', // radio切换时清空不掉图片值  所以采用ref方法清空
				worksUrl: '',
			})
		})
		this.childRef.current.removeFileList()
	}
	getText = v => {
		console.log(v)
		this.props.form.setFieldsValue({
			'introduce': v
		});
	}
	async getList() {
		axios.post('activityController/getActivityVoteDetailsList', {
			activityId: 1,
			...this.state.searchData,
			userName: this.state.name
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					dataSource: res.data.data.list,
					searchData: {
						pageNum: res.data.data.pageNum,
						pageSize: res.data.data.pageSize,
						total: res.data.data.total
					}
				})
			}
		})
	}
	delQscode(id) {
		axios.post(`activityController/delActivityVoteDetails`, {
			activityId: 1,
			activityVoteDetailId: id
		}).then(res => {
			if (res.data.code === '200') {
				message.success('删除成功')
				this.getList()
			} else {
				message.error(res.data.msg)
			}
		})
	}
	delAllQscode() {
		axios.post(`activityController/batchDelActivityVoteDetails`, {
			activityId: 1,
			
		}).then(res => {
			if (res.data.code === '200') {
				message.success('删除成功')
				this.getList()
			} else {
				message.error(res.data.msg)
			}
		})
	}
	getZmToken() {
		let _this = this;
		axios.get("/uplodController/get7menrToken?type=1").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					zmToken: res.data.data.token,
					url: res.data.data.url
				})
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
	getToken() {
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					url: res.data.data.url
				})
				// this.props.getQiniuUrl(res.data.data.url)
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
	getQiniuUrl = v => {
		this.setState({
			qiuniuUrl: v
		})
	}
	exportData() {
		// window.location.href = `http://192.168.40.55:8686/video-wechat-manager/api/userController/export?endTime=${this.state.endTime}&startTime=${this.state.startTime}&autoSyn=${this.state.autoSyn}&isHas=${this.state.isHas}&isTeacher=${this.state.isTeacher}`
		axios.get(`/activityController/export?activityId=1`, { responseType: 'blob' }).then(res => {
			const link = document.createElement('a')
			let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
			link.style.display = 'none'
			link.href = URL.createObjectURL(blob)
			link.setAttribute('download', '用户投票列表.xlsx')
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		})
	}
	getQiniu = (file) => {
		let data = {
			token: file.type.split('/')[1]!=='mp4' ? this.state.zmToken : this.state.token,
			url: this.state.url,
			key: `${Date.now()}-${file.name}`
		}
		return { ...data }
	}
	render() {
		const { visible, dataSource, columns, modelTitel, name, searchData, userName, slogan, introduce, fileType, worksUrl, voteUrl} = this.state;
		const { getFieldDecorator } = this.props.form
		const pagination = {
			showSizeChanger: true,
			total: searchData.total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal: () => `共 ${searchData.total} 条`,
			onShowSizeChange: (current, pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.getList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.getList(searchData)
			},
		}
		const _this = this
		const props = {
			name: 'file',
			action: 'https://up-z1.qiniup.com',
			accept: '.mp4,.avi,.mov,.wmv',
			data: _this.getQiniu,
			headers: {
				authorization: 'authorization-text',
			},
			beforeUpload(file, fileList) {
				// let data = {
				// 	token: file.type.split('/')[1]!=='mp4' ? zmToken : token,
				// 	url: url,
				// 	key: file.name
				// }
				if(fileList.length > 1){
					return	message.warning("只能上传一个文件")
				}
			},
			onChange(info) {
				console.log(info, '参数值');
				if(info.status === 'done' ) {
					message.success(`${info.file.name} file uploaded successfully`);
				}else {
					if (info.file.status !== 'uploading') {
						console.log(info.file, info.fileList);
					}
					if (info.file.status === 'done') {
						message.success(`${info.file.name} file uploaded successfully`);
					} else if (info.file.status === 'error') {
						message.error(`${info.file.name} file upload failed.`);
					}
				}
			},
		};
		return (
			<div>
				<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>H5投票活动</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
					<div>
						<Input allowClear value={name} style={{ width: '260px', height: '40px', marginRight: '20px' }} placeholder="请输入姓名" onChange={(e) => {
							this.setState({
								name: e.target.value
							})
						}}></Input>
						<Button className='my-button-primary' style={{ marginRight: '20px' }} onClick={() => {
							this.getList()
						}} type='primary'>搜索</Button>
						<span className='my-button-txt' onClick={() => {
							this.setState({ name: '' }, () => {
								this.getList()
							})
						}} type='primary'>重置</span>
					</div>
					<div>
						<Button className='my-button-primary delete-btn' type="danger" onClick={() => {
							Modal.confirm({
								title: '删除',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p>删除后不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									this.delAllQscode()
								},
							});
						}}>批量删除</Button>
						<Button className='my-button-primary' style={{ marginLeft: '20px', marginBottom: '20px' }} type='primary' onClick={() => {
							this.exportData()
						}}>导出</Button>
						<Button style={{ marginLeft: '20px', marginBottom: '20px' }} className='my-button-primary' type='primary' onClick={() => { this.showModal() }}>新增</Button>
					</div>

				</div>
				<Table pagination={pagination} dataSource={dataSource} columns={columns} rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')} rowKey={record => record.id} />
				<Modal
					width={800}
					getContainer={false}
					title={modelTitel}
					okText="确认"
					cancelText="取消"
					visible={visible}
					maskClosable={false}
					destroyOnClose
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
				>
					<Form labelCol={{ span: 3 }} wrapperCol={{ span: 21 }} onSubmit={this.handleOk}>
						<FormItem label={"参与人姓名"}>
							{getFieldDecorator('userName', {
								initialValue: modelTitel === '编辑' ? userName : '',
								rules: [{ required: true, message: '请输入参与人姓名!' }, { max: 30, message: '最多输入30个字符' }],
							})(
								<Input allowClear placeholder='请输入参与人姓名' />
							)}
						</FormItem>

						<FormItem label="作品类型" name="fileType">
            {getFieldDecorator('fileType', {
              rules: [
                {required: true,message: '请选择作品类型'},
              ],
              initialValue: modelTitel === '编辑' ? fileType : 0,
              })(
              <Radio.Group onChange={this.radioChange}>
                	<Radio value={0}>视频</Radio>
									<Radio value={1}>图片</Radio>
              </Radio.Group>)}
						</FormItem>
						<Form.Item label="参赛图片" style = { {display: this.state.fileType === 1?"":"none" }}>
							{getFieldDecorator('voteUrl', {
								initialValue: modelTitel==='编辑'? voteUrl: '',
								rules: [{ required: true, message: '请上传参赛图片!' }],
							})(
								<UploadQiniu ref={this.childRef} getQiniuUrl={this.getQiniuUrl}  />
							)}
						</Form.Item>
						<Form.Item label="参赛视频"  style = { {display: this.state.fileType === 0?"":"none" }}>
							{getFieldDecorator('worksUrl', {
								valuePropName: 'fileList',
								initialValue: modelTitel === '编辑' ? [worksUrl] : '',
								getValueFromEvent: e => {
									if (Array.isArray(e)) {
										return e;
									}
									return e && e.fileList;
								},
								rules: [{ required: true, message: '请上传作品!' }],
							})(
								<Upload {...props}>
									<Button>
										<Icon type="upload" />选择视频
									</Button>
								</Upload>,
							)}
						</Form.Item>
						<FormItem label={"队伍口号"}>
							{getFieldDecorator('slogan', {
								initialValue: modelTitel === '编辑' ? slogan : '',
								rules: [{ required: true, message: '请输入队伍口号!' }, { max: 50, message: '最多输入50个字符' }],
							})(
								<Input allowClear placeholder='请输入队伍口号' />
							)}
						</FormItem>
						<FormItem label="项目详情" name="introduce">
							{getFieldDecorator('introduce', {
								rules: [
									{ required: true, message: '请输入项目详情' },
									{ max: 2000, message: '最多输入500个字!' }
								],
								initialValue: modelTitel === '编辑' && introduce ? introduce : ''
							})(
								<Wangeditor content={introduce} getText={this.getText} />
							)}
						</FormItem>
					</Form>
				</Modal>
			</div>
		)
	}
}

export default Form.create()(VotingActivities)